import FirebaseRemoteConfig from "../libs/firebase";
import { store } from "../store";
import { RemoteConfigInReview } from "../types/RemoteConfig.type";

export const getInReviewApp = async () => {
  const remoteConfig = FirebaseRemoteConfig.getInstance();
  await remoteConfig.fetchAndActivateConfig();
  const inReview = await remoteConfig.getValue<RemoteConfigInReview>(
    "in_review"
  );

  const appVersion = getAppVersion();
  const isActive = inReview?.active === "true";
  const isVersionMatch = inReview?.version === appVersion;

  if (isActive && isVersionMatch) {
    return inReview;
  }

  return null;
};

const getAppVersion = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const appVersion = urlParams.get("app_version");
  if (!appVersion) {
    return getAppVersionFromStore();
  }
  return appVersion;
};

const getAppVersionFromStore = () => {
  return store.getState().appInfo?.appInfo?.version;
};
